import React from 'react';
import {Modal} from 'react-bootstrap';

const DeleteCertificateModal = (props)=>{
    const {certificate, onHide, onConfirm} = props;
    return (
        <Modal
            show={true}
            onHide={onHide}>
            <Modal.Header closeButton>
                <Modal.Title>Eliminar constancia</Modal.Title>
            </Modal.Header>
            <Modal.Body >
                <p>¿Estás seguro que deseas eliminar la constancia&nbsp;<strong>{certificate.name}</strong>?</p>
                <p>Esta acción no se puede deshacer.</p>
            </Modal.Body>
            <Modal.Footer>
                <button onClick={ onHide } className='btn btn-primary pull-left'>Cancelar</button>
                <button className='btn btn-danger' onClick={ ()=>onConfirm( certificate ) }>Eliminar</button>
            </Modal.Footer>
        </Modal>
    );
};

export default DeleteCertificateModal;


// WEBPACK FOOTER //
// ./src/App/scenes/AppFrame/scenes/Certificates/components/DeleteCertificateModal/index.jsx